import { useEffect, useState } from 'react';
import { Tag } from '@bringg/types';

import { useAuth } from 'Providers';

export function useTags(): { tags: Tag[]; isLoadingTags: boolean } {
  const { dashboardSdk, isLoggedIn } = useAuth();
  const [tags, setTags] = useState<Tag[]>([]);
  const [isLoadingTags, setIsLoadingTags] = useState(false);

  useEffect(() => {
    if (!dashboardSdk || !isLoggedIn) {
      setTags([]);
      setIsLoadingTags(true);
      return;
    }

    async function fetchTags() {
      try {
        setTags(await dashboardSdk.sdk.tags.getAll());
      } finally {
        setIsLoadingTags(false);
      }
    }

    fetchTags();
  }, [dashboardSdk, isLoggedIn]);

  return { tags, isLoadingTags };
}
